module.exports = __webpack_public_path__ + "static/media/Ma.f5d3e9c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/Ma.mp3
// module id = 76
// module chunks = 0